import { fetchIpfsMetadata } from '../../utils/utils'

export interface ProfileCreator {
  name: string // this is always the address, Hub should resolve to username where needed
  link: string
}

export interface ProfileMetadata {
  creator: ProfileCreator
  name: string // display name
  description: string // bio
  image: string // avatar
  bannerImage: string // banner
}

export const loadProfile = async (url: string): Promise<ProfileMetadata | undefined> => {
  try {
    const metadata = await fetchIpfsMetadata(url)
    return metadata as ProfileMetadata
  } catch (e) {
    console.error('Error fetching profile metadata', e)
    return undefined
  }
}
